import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import type { ExperienceFlag } from '@/features/experience-shell/types.ts'
import {
	type HttpGetExperienceFlags,
	httpGetExperienceFlags
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { QUERY_KEYS } from '@/query-client'

export const useGetExperiencesFlags = (
	params: Omit<HttpGetExperienceFlags['params'], 'response_type'>,
	options?: Omit<UseQueryOptions<ExperienceFlag[]>, 'queryKey' | 'queryFn'>
) => {
	return useQuery({
		queryKey: [QUERY_KEYS.EXPERIENCES_FLAGS, params],
		queryFn: () =>
			httpGetExperienceFlags({
				params: { ...params, response_type: 'extended' }
			}),
		...options
	})
}
